// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Rails Internals

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

// Ahoy analytics tracking
import ahoy from "ahoy.js";

// Configure Ahoy
ahoy.configure({
  urlPrefix: "",
  visitsUrl: "/ahoy/visits",
  eventsUrl: "/ahoy/events",
  page: null,
  platform: "Web",
  useBeacon: true,
  startOnReady: true,
  trackVisits: true,
  cookies: true,
  cookieDomain: null,
  headers: {},
  visitParams: {},
  withCredentials: false,
  visitDuration: 4 * 60, // 4 hours in minutes
  visitorDuration: 2 * 365 * 24 * 60 // 2 years in minutes
});

// Make ahoy globally available
window.ahoy = ahoy;

// Track page view helper function
function trackPageView() {
  try {
    ahoy.trackView();
  } catch (e) {
    console.error("Ahoy trackView error:", e);
  }
}

// Track page views on Turbolinks navigation
document.addEventListener("turbolinks:load", trackPageView);

// Also track on initial page load (fallback for non-Turbolinks pages)
if (document.readyState === "complete" || document.readyState === "interactive") {
  // DOM already loaded, track immediately
  setTimeout(trackPageView, 100);
} else {
  document.addEventListener("DOMContentLoaded", function() {
    setTimeout(trackPageView, 100);
  });
}

// require("jquery")
require("popper.js")
require("bootstrap")

import moment from 'moment';
window.moment = moment;

require("daterangepicker")

import owlCarousel from "owl.carousel";

require('jquery-ui');

import Player from '@vimeo/player';
window.Player = Player;

require("packs/main")
require("js-cookie")

import("packs/plugins/css/daterangepicker.min")
import('styles/app.scss');

//import Cookies from 'js.cookie'; <--------- had to disable because line triggering error during Capistrano compilation
import Cookies from 'js-cookie';
window.Cookies = Cookies;

export * from './helpers/helpers'

export * from './UIModules/tabs'
export * from './UIModules/smallNotification'
export * from './UIModules/largeNotification'
export * from './UIModules/copyToClipboard'
export * from './UIModules/dropdownMenuCustom'

export * from './UIModules/sendViaEmailValidation'
export * from './UIModules/emailSubmit'

export * from './UIModules/conversationValidation'
export * from './UIModules/createNewConversation'
export * from './UIModules/chatbot'

export * from './UIModules/addToCollectionValidation'
export * from './UIModules/teamCardSession'

// Create global Packs object for legacy code in application.html.erb
import * as TabsExports from './UIModules/tabs';
import * as SmallNotificationExports from './UIModules/smallNotification';
import * as LargeNotificationExports from './UIModules/largeNotification';
import * as CopyToClipboardExports from './UIModules/copyToClipboard';
import * as DropdownMenuExports from './UIModules/dropdownMenuCustom';
import * as SendViaEmailExports from './UIModules/sendViaEmailValidation';
import * as EmailSubmitExports from './UIModules/emailSubmit';
import * as ConversationValidationExports from './UIModules/conversationValidation';
import * as CreateNewConversationExports from './UIModules/createNewConversation';
import * as ChatbotExports from './UIModules/chatbot';
import * as AddToCollectionExports from './UIModules/addToCollectionValidation';
import * as TeamCardSessionExports from './UIModules/teamCardSession';
import * as HelpersExports from './helpers/helpers';

window.Packs = window.Packs || {};
window.Packs.application = {
    ...TabsExports,
    ...SmallNotificationExports,
    ...LargeNotificationExports,
    ...CopyToClipboardExports,
    ...DropdownMenuExports,
    ...SendViaEmailExports,
    ...EmailSubmitExports,
    ...ConversationValidationExports,
    ...CreateNewConversationExports,
    ...ChatbotExports,
    ...AddToCollectionExports,
    ...TeamCardSessionExports,
    ...HelpersExports
};

require("packs/drop")

// PDF.js viewer
import "./pdf_viewer";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:
